import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RESULTS, IMAGES, STUDIO, VIDEOS } from '../data/mock';
import { usePageMeta } from '../components/Layout';
import { Reveal, SectionHeader, PageHero, CloseCTA, ReviewWall } from '../components/Shared';

export default function Results() {
  usePageMeta(
    'Results — Member Transformations',
    'Real PITFIT member results: fat loss, muscle gained, and 5K PRs — earned 60 minutes at a time in Uptown Dallas. Read the stories, then try a class for $15.'
  );

  return (
    <>
      <PageHero
        tag="Proof Of Work"
        title="Results earned in the PIT."
        sub="No filters, no sponsored posts. These are members who showed up 3–4 times a week and let the format do its job."
        video={VIDEOS.classes}
      />

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {RESULTS.map((r, i) => (
              <Reveal key={r.name} delay={i * 80}>
                <div className="glass-card glass-card-hover overflow-hidden h-full flex flex-col">
                  <div className="relative">
                    <img src={r.img} alt={`${r.name}, PITFIT member transformation`} className="w-full h-64 object-cover object-top" loading="lazy" />
                    <div className="absolute bottom-4 left-4 glass-card px-4 py-2.5 flex items-baseline gap-2" style={{ borderColor: 'rgba(125,167,255,0.45)' }}>
                      <span className="font-display font-bold text-xl text-white">{r.stat}</span>
                      <span className="font-mono-pf text-[11px] uppercase tracking-[0.1em] text-muted-pf">in {r.period}</span>
                    </div>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <p className="text-[#cdd5e4] text-[16px] leading-relaxed flex-1">“{r.quote}”</p>
                    <p className="font-mono-pf text-[12px] uppercase tracking-[0.12em] text-muted-pf mt-4">— {r.name} · PITFIT member</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad" style={{ background: 'var(--pf-bg2)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionHeader tag="The Review Wall" title={`${STUDIO.rating}★ · ${STUDIO.reviewCount}+ verified reviews`} center />
          <ReviewWall />
        </div>
      </section>

      <section className="section-pad !pb-0">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="h-section text-white">The formula isn't secret.</h2>
            <p className="text-muted-pf mt-4 text-[17px] max-w-2xl mx-auto">
              3–4 classes a week · the weekly split · honest effort · a coach who won't let you coast. Results follow attendance — every time.
            </p>
            <Link to="/the-workout" className="btn-ghost mt-7">See How The Workout Works <ArrowRight size={16} /></Link>
          </Reveal>
        </div>
      </section>

      <CloseCTA title="Your before photo is today." sub="Start with a $15 class — no membership, no commitment. The rest is showing up." />
    </>
  );
}
